const URL_PATTERN = /^[a-z][a-z0-9+.-]*:/i;
const ALLOWED_LINK_PROTOCOLS = new Set(['http:', 'https:', 'mailto:', 'tel:']);

export const normalizeHref = (href: string): string | null => {
    const trimmed = href.trim();
    if (!trimmed) return null;
    if (trimmed.startsWith('__') && trimmed.endsWith('__')) return trimmed;
    if (trimmed.startsWith('#')) return trimmed;

    const normalized = URL_PATTERN.test(trimmed) ? trimmed : `https://${trimmed}`;

    try {
        const url = new URL(normalized);
        return ALLOWED_LINK_PROTOCOLS.has(url.protocol) ? normalized : null;
    } catch {
        return null;
    }
};

export const normalizeImageUrl = (href: string): string | null => {
    const normalized = normalizeHref(href);
    if (!normalized) return null;
    try {
        const url = new URL(normalized);
        return url.protocol === 'http:' || url.protocol === 'https:' ? normalized : null;
    } catch {
        return null;
    }
};
